import { combineSlices } from "@reduxjs/toolkit";
import { projectSlice } from "./slices/projectSlice";
import { editorsSlice } from "./slices/editorsSlice";
import { workspaceSlice } from "./slices/workspaceSlice";
import { resourceTreeSlice } from "./slices/resourceTreeSlice";
import { historySlice } from "./slices/historySlice";
import { dialogSlice } from "./slices/dialogSlice";
import { notificationsSlice } from "./slices/notificationsSlice";
export const reducer = combineSlices(dialogSlice, editorsSlice, historySlice, notificationsSlice, projectSlice, resourceTreeSlice, workspaceSlice);
export const injectedDialogSlice = dialogSlice.injectInto(reducer);
export const injectedEditorsSlice = editorsSlice.injectInto(reducer);
export const injectedHistorySlice = historySlice.injectInto(reducer);
export const injectedNotificationsSlice = notificationsSlice.injectInto(reducer);
export const injectedProjectSlice = projectSlice.injectInto(reducer);
export const injectedResourceTreeSlice = resourceTreeSlice.injectInto(reducer);
export const injectedWorkspaceSlice = workspaceSlice.injectInto(reducer);
//# sourceMappingURL=reducer.js.map